import { createAction } from 'redux-actions';
import { actionTypePrefix } from './constants';
import { putEntities } from '../entities/actions';
import { deviationSchema } from '../normalizr/schemas/deviation';
import { normalize } from 'normalizr';
import { pushModal } from '../../Modals/redux/basicActions';
import { ModalType } from '../../Modals/redux/types';
import { createWithDeviation } from '../../DaEditorWrapper/utils';
export var fetchDeviation = createAction("".concat(actionTypePrefix, ".FETCH_DEVIATION"), function (payload) { return payload; });
export var editDeviation = createAction("".concat(actionTypePrefix, ".EDIT_DEVIATION"), function (payload) { return payload; });
export var editDeviationSuccess = createAction("".concat(actionTypePrefix, ".EDIT_DEVIATION_SUCCESS"), function (payload) { return payload; });
export var deleteDeviation = createAction("".concat(actionTypePrefix, ".DELETE_DEVIATION"), function (payload) { return payload; });
export var deleteDeviationSuccess = createAction("".concat(actionTypePrefix, ".DELETE_DEVIATION_SUCCESS"), function (payload) { return payload; });
export var updateDeviationEntity = function (deviation) {
    var entities = normalize(deviation, deviationSchema).entities;
    return putEntities({ entities: entities });
};
export var updateNormalizedDeviationEntity = function (normalizedDeviation) {
    var _a, _b;
    return putEntities({
        entities: (_a = {},
            _a[deviationSchema.key] = (_b = {},
                _b[normalizedDeviation.entityId] = normalizedDeviation,
                _b),
            _a),
    });
};
export var shareDeviationToPost = function (deviation) {
    return pushModal(ModalType.STATUS_UPDATE, {
        wrapInModal: false,
        params: {
            initialState: createWithDeviation(deviation),
        },
    });
};
//# sourceMappingURL=actionCreators.js.map